var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"main-content"}},[_c('section',{staticClass:"wrapper"},[_c('section',{staticClass:"login container-fluid"}),_c('div',{staticClass:"container box-login"},[_c('div',{staticClass:"row"})])])])
}]

export { render, staticRenderFns }